// "What would these trades have done to a prop account?" for the free report card: walks the
// trades through a firm preset's rules (balance.js PRESETS) day by day and says when the
// account would have hit its daily loss limit or max loss, and where it ends up.
import { netPnl, tradingDayKey } from './pnl';

export function ruleCheck(trades, preset) {
  const start = preset.size;
  const mll = preset.maxLossLimit || 0;
  const lock = start + (preset.trailLockOffset || 0);
  const sorted = [...trades].sort((a, b) => new Date(a.date) - new Date(b.date));
  const days = new Map();
  for (const t of sorted) {
    const k = tradingDayKey(t.date);
    if (!days.has(k)) days.set(k, []);
    days.get(k).push(t);
  }
  let balance = start;
  let floor = mll ? start - mll : null;
  let blownOn = null;
  let targetOn = null;
  const dailyHits = [];
  const dayNets = [];
  for (const [day, list] of days) {
    let dayNet = 0;
    let dailyHit = false;
    for (const t of list) {
      const net = netPnl(t);
      balance += net;
      dayNet += net;
      if (mll && preset.drawdownType === 'trailing_intraday') floor = Math.min(lock, Math.max(floor, balance - mll));
      if (mll && !blownOn && balance <= floor) blownOn = day;
      if (preset.dailyLossLimit && !dailyHit && dayNet <= -preset.dailyLossLimit) dailyHit = true;
    }
    if (dailyHit) dailyHits.push({ day, net: dayNet });
    dayNets.push({ day, net: dayNet });
    // End-of-day trailing: the level follows the closing balance, up to the lock.
    if (mll && (preset.drawdownType === 'trailing_eod' || !preset.drawdownType)) floor = Math.min(lock, Math.max(floor, balance - mll));
    if (preset.profitTarget && !targetOn && balance - start >= preset.profitTarget) targetOn = day;
  }
  const change = balance - start;
  const bestDay = Math.max(0, ...dayNets.map((d) => d.net));
  const consistencyPct = preset.consistencyLimit && change > 0 && bestDay > 0
    ? (bestDay / (preset.consistencyBase === 'target' && preset.profitTarget ? preset.profitTarget : change)) * 100 : null;
  return {
    start, balance, change, floor, blownOn, targetOn, dailyHits,
    toBlow: mll ? balance - floor : null,
    consistencyPct, consistencyOk: consistencyPct === null || consistencyPct <= preset.consistencyLimit,
    days: dayNets.length,
  };
}
